const KNORIA_LOGO_URL = "/knoria_logo_nobg.png";

export function KnoriaLogo({ size = 40, className = "" }) {
  return (
    <img
      src={KNORIA_LOGO_URL}
      alt="KNORIA"
      style={{ height: size }}
      className={`object-contain ${className}`}
    />
  );
}

export { KNORIA_LOGO_URL };
